import { cn } from "@/lib/utils";

type ChartSkeletonProps = {
  className?: string;
  height?: string;
  colSpan?: number;
};

export const ChartSkeleton = ({
  className,
  height = "h-[200px]",
  colSpan,
}: ChartSkeletonProps) => (
  <div
    className={cn("h-full rounded-2xl border border-border bg-card p-6", className)}
    style={{ gridColumn: colSpan ? `span ${colSpan}` : undefined }}
  >
    <div className="mb-4 h-4 w-1/3 animate-pulse rounded bg-muted" />
    <div className={cn("animate-pulse rounded bg-muted", height)} />
  </div>
);

export const StatSkeleton = () => (
  <div className="rounded-2xl border border-border bg-card p-6">
    <div className="mb-3 h-3 w-2/3 animate-pulse rounded bg-muted" />
    <div className="h-10 w-1/3 animate-pulse rounded bg-muted" />
  </div>
);
